import { LinkProps } from "@chakra-ui/react";

const selectedNavLinkProps: LinkProps = {
  bg: "rgba(255, 255, 255, 0.2)",
  color: "white",
  fontWeight: 600,
  rounded: "sm",
};

export default selectedNavLinkProps;
